/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * RedLiveIcon - Auto-generated from icon.js
 */
export const RedLiveIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="27" height="21" viewBox="0 0 27 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path fillRule="evenodd" clipRule="evenodd" d="M4 3C1.79086 3 0 4.79086 0 7V14C0 16.2091 1.79086 18 4 18H23C25.2091 18 27 16.2091 27 14V7C27 4.79086 25.2091 3 23 3H4ZM8.27 14.36H4V7H5.16V13.38H8.27V14.36ZM10.7264 14.36H9.56641V7H10.7264V14.36ZM13.9723 14.36H15.3423L17.6423 7H16.4623L15.3723 10.81C15.2664 11.1808 15.1722 11.5282 15.0784 11.8737L15.0784 11.8737L15.0784 11.8738L15.0784 11.8738C14.9598 12.311 14.842 12.7452 14.7023 13.22H14.6523C14.5146 12.7698 14.405 12.356 14.2951 11.9415C14.1976 11.5736 14.0999 11.2051 13.9823 10.81L12.8923 7H11.6623L13.9723 14.36ZM23.0498 14.36H18.5898V7H22.9398V7.97H19.7498V10.02H22.4498V11H19.7498V13.38H23.0498V14.36Z" fill="#D0021B" />
	</svg>
);

export default RedLiveIcon;
